import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Form } from 'common/components';
import { formatMoney } from 'accounting-js';
import * as DF from 'fixedassets/components/detail/field';

class AssetDetailGeneral extends Component {
  render = () => (
    <Form.Section title={this.props.t('assets.section.project')}>
      <div className="row">
        <DF.Relation label={'assets.fields.project'} value={this.props.asset._project} />
        <DF.Text
          label={'assets.fields.projectPrice'}
          value={formatMoney(this.props.asset.projectPrice || 0)}
        />
        <DF.Text label={'assets.fields.buyOrder'} value={this.props.asset.buyOrder} />
        <DF.Text label={'assets.fields.approvalNumber'} value={this.props.asset.projectApprovalNumber} />
      </div>
    </Form.Section>
  );
}

export default translate()(AssetDetailGeneral);



// WEBPACK FOOTER //
// src/modules/secured/modules/fixedassets/components/detail/AssetDetailProject.js